module.exports = __webpack_public_path__ + "img/body-3.d8708a4d.png";